'use strict';
import {stateGo} from 'redux-ui-router';
import 'rxjs/add/operator/map';
import fuse from '../../../_libs/redux-fusion';
import {stateIncludes} from '../../../config/reducers/routerReducer';
import {LinkComponent} from './LinkComponent';

const StreamedComponent = (state$, dispatch) => (props$) => {
  return props$
    .map(props => ({
      ...props,
      isActive: getIsActivated(props),
      onNavTo: () => {
        if (props.to && props.toParams) {
          dispatch(stateGo(props.to, props.toParams));
        } else if (props.to) {
          dispatch(stateGo(props.to));
        }
      },
    }));
};

export const LinkContainer = fuse(StreamedComponent)(LinkComponent);

function getIsActivated(props) {
  const activeState = props.activeStateName || props.to;
  return activeState && props.navState ? stateIncludes(props.navState, activeState) : false;
}



// WEBPACK FOOTER //
// ./src/js/app/components/Link/LinkContainer.js